export function isJSON(s: string) {
  try {
    JSON.parse(s);
  } catch (e) {
    return false;
  }
  return true;
}
